module.exports = __webpack_public_path__ + "static/img/040905.ab488762.png";